import { FormControlLabel, FormGroup } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import React, { useEffect, useState } from "react";
import { useSystem } from "context/systemContext.jsx";
import { useUser } from "context/userContext";
import DataService from "services/DataService";

import "./ButtonSystemControl.css";
import constants from "../../constants/system";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginRight: 10,
  // MuiTypography-root  MuiTypography-body1
  "& .MuiFormControlLabel-label": {
    color: "red",
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#f44336",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default function ButtonSystemControl() {
  const { isAlive, setIsAlive } = useSystem();
  const { credential, language } = useUser();
  const [label, setLabel] = useState("");
  useEffect(() => {
    isAlive
      ? setLabel(constants.system.labelButton.avaiable[language])
      : setLabel(constants.system.labelButton.disabled[language]);
  }, [language]);
  const handleChange = async () => {
    try {
      const authorization = {
        headers: {
          Authorization: credential,
        },
      };
      const response = await DataService.changeStatusSystem(authorization);
      setIsAlive(response.data);
      setLabel(
        response.data
          ? constants.system.labelButton.avaiable[language]
          : constants.system.labelButton.disabled[language]
      );
    } catch (e) {
      alert(e);
    }
  };

  return (
    <div>
      <FormGroup>
        <FormControlLabel
          control={
            <IOSSwitch
              sx={{ m: 1 }}
              defaultChecked
              checked={isAlive}
              onChange={handleChange}
            />
          }
          label={<div className={!isAlive ? "inativo" : ""}>{label}</div>}
        />
      </FormGroup>
    </div>
  );
}
